import { apiClient } from './apiClient';

export type EntityType = {
  einValidFormat: string;
  federalLegalId: string;
  id: number;
  name: string;
};

export type EntityTypeResponse = {
  results: EntityType[];
  totalCount: number;
};

export type ValidateEntityTypesPayload = {
  dateEstablished?: string;
  closeDate?: string;
  entityTypes: {
    id: number;
    startingDate?: string;
    endingDate?: string;
    description: string;
  }[];
};

export const getEntityTypes = (): Promise<EntityTypeResponse> => {
  return apiClient.get(`/entity-types`, {});
};

export const validateEntityTypesHistory = (
  clientId: number,
  payload: ValidateEntityTypesPayload
): Promise<{ isValid: boolean; validationErrors?: string[] }> => {
  return apiClient.post(
    `clients/${clientId}/validate-entity-types-history`,
    payload
  );
};
